import React, { Fragment, useState } from "react";
import "../style/index.scss";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Banner from "../components/sections/banner"
import { Container, Row, Col, Button } from "react-bootstrap";
import bgImg from "../images/headers/subheader_blue.svg";
import bannerImage from "../images/box-headers/rhodecentral.jpg";
import ContactForm from "../components/contact-form";

// markup
const IndexPage = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const customHtml = () => (
    <>
      <Container>
        <Row className="mb-2">
          <Col>
            <div className="list-item">
              <i className="fas fa-check font-green mr-2" />
              {"10 Gbps VostroNet fibre connection"}
            </div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <div className="list-item">
              <i className="fas fa-check font-green mr-2" />
              {"Ready on day one guarantee"}
            </div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <div className="list-item">
              <i className="fas fa-check font-green mr-2" />
              {"Wi-Fi coverage around your building or precinct"}
            </div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <div className="list-item">
              <i className="fas fa-check font-green mr-2" />
              {"Ancillary services offered at zero cost (i.e. CCTV & MATV)"}
            </div>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <div className="list-item">
              <i className="fas fa-check font-green mr-2" />
              {"We manage and upgrade the network post-build"}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
  return (
    <>
      <Layout>
        <SEO title="VostroNet - Smarter Internet - Internet Provider">
          <meta name="description" content="VostroNet is the leading end-to-end provider of fibre-to-the-premises and Wi-Fi networks for multi-dwelling developments, delivering smarter internet." />
        </SEO>
        <ContactForm show={show} handleClose={handleClose} />
        <Banner
          customHtml={customHtml}
          subpage
          bgImg={bgImg} data={{
            title: {
              name: "Connect to VostroNet's Future-proof Network",
            },
            subtitles: [
              {
                name: `High-speed fibre-to-the-premises and Wi-Fi infrastructure deployed and operated seamlessly at your development`,
                className: "fw-400",
              },
            ],
            img: bannerImage,
          }}
          hideScrollButton
          customButtons={(
            <Container className="mt-5 contact-group-up">
              <Row className="mb-3">
                <Col xs={12}>
                  <div className="contact-text">
                    Contact us today
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="contact-text">
                    to receive a quote for your development
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="auto">
                  <Button variant="green" className="btn-banner mb-3" onClick={handleShow}>
                    {"Get a quote"}
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button variant="outline-white" className="btn-banner-secondary btn-blue" rel="noopener" href="https://vost.ro/lpfttplm">
                    {"Learn more"}
                  </Button>
                </Col>
              </Row>
            </Container>
          )} />
        <Container className="mt-4 contact-group-down">
          <Row className="mb-3">
            <Col xs={12}>
              <div className="contact-text">
                Contact us today
              </div>
            </Col>
            <Col xs={12}>
              <div className="contact-text">
                to receive a quote for your development
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="auto">
              <Button variant="green" className="btn-banner mb-3" onClick={handleShow}>
                {"Get a quote"}
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="outline-green" className="btn-banner-secondary" rel="noopener" href="https://vost.ro/lpfttplm">
                {"Learn more"}
              </Button>
            </Col>
          </Row>
        </Container>
      </Layout>
    </>
  )
}

export default IndexPage
